export default "__VITE_ASSET__CmTamvgV__"